import { useSignal } from '@preact/signals';
import { useEffect } from 'preact/hooks';

export function useIsVisible(elementId: string, rootMargin = '0px') {
	const isVisible = useSignal(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				isVisible.value = !!entry?.isIntersecting;
			},
			{ rootMargin },
		);

		const observeElement = () => {
			const element = document.getElementById(elementId);
			if (element) {
				observer.observe(element);
			}
		};

		observeElement();

		document.addEventListener('astro:page-load', observeElement);

		return () => {
			observer.disconnect();

			document.removeEventListener('astro:page-load', observeElement);
		};
	}, []);

	return isVisible;
}
